module.exports = __webpack_public_path__ + "img/noDataImg.949871b3.png";